import { Boton, Grilla, GrillaEl, PilaV, Texto } from '@/components/atomos';
import { AVISOS } from '@/routes/AppRoutes';
import { Heading, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import QueEsFactoring from '@/assets/img/que_es_factoring.webp';

const SobreNosotros = () => {
  return (
    <PilaV alignItems={'start'} spacing={4}>
      <Heading w='full' maxW='800px' style={{ textWrap: 'pretty' }}>
        Brindamos financiamiento en Factoring de forma 100%{' '}
        <Texto as={'span'} color={'bGreen.600'}>
          {' '}
          online, transparente y segura.
        </Texto>
      </Heading>
      <Grilla templateColumns={'repeat(2, 1fr)'} gap={4}>
        <GrillaEl colSpan={1} as={PilaV} w={'full'} alignItems={'start'}>
          <Texto fontSize={'xl'}>
            El Factoring es una alternativa de financiamiento que permite a{' '}
            <Texto as='b' fontWeight={'medium'}>
              empresas o personas naturales
            </Texto>{' '}
            obtener liquidez inmediata, mediante la cesión o venta de sus
            cuentas por cobrar.
          </Texto>
          <Boton
            variant={'link'}
            colorScheme='bGreen'
            as={Link}
            target='_blank'
            to={AVISOS.TERMINOS}
          >
            Ver condiciones del servicio
          </Boton>
        </GrillaEl>
        <GrillaEl colSpan={1} as={Image} src={QueEsFactoring} w={'full'} />
      </Grilla>
    </PilaV>
  );
};

export default SobreNosotros;
